<template>
  <div>
    <search-module @submit="submitSearch" />

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findModules } from '@/api/module'
import Pagination from '@/components/Pagination'
import SearchModule from '@/views/modules/Search'

export default {
  name: 'ModuleList',
  components: {
    Pagination,
    SearchModule
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {
        per_page: 10
      },
      columns: [
        {
          title: 'IMEI',
          dataIndex: 'imei',
          width: 180,
          fixed: 'left'
        },
        {
          title: '模组厂商',
          dataIndex: 'module_producer_name',
          width: 140
        },
        {
          title: '模组型号',
          dataIndex: 'module_model_name',
          width: 140
        },
        {
          title: 'SN',
          dataIndex: 'sn',
          width: 160
        },
        {
          title: '箱号',
          dataIndex: 'box_number',
          width: 120
        },
        {
          title: '盘号',
          dataIndex: 'reel_number',
          width: 120
        },
        {
          title: '订单编号',
          dataIndex: 'order_no',
          width: 220,
          ellipsis: true
        },
        {
          title: '划拨时间',
          dataIndex: 'allocated_at',
          width: 170
        }
      ]
    }
  },
  computed: {
    agentId() {
      if (this.$route.query.agent_id) {
        return parseInt(this.$route.query.agent_id)
      }
      return this.$store.getters.userAgentId
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search
      )
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findModules(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
